/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Storytelling
 * Copyright IBM Corp. 2017, 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'bacontentnav/ui/views/SaveAsView',
	'baglass/core-client/js/core-client/ui/properties/CheckBox',
	'text!./templates/ExportView.html',
	'../nls/StringResources'
],
function(SaveAsView, CheckBox, template, stringResources) {

	const ExportView = SaveAsView.extend({

		templateString: template,
		events: {},

		init: function() {
			ExportView.inherited('init', this, arguments);
		},

		render: function() {
			ExportView.inherited('render', this, arguments);

			// TODO: Use ba-ui-toolkit checkbox here?
			this._oLoadCheckBox = new CheckBox({
				'id': 'load_after_export',
				'el': this.$('.loadAfterExportContainer'),
				'name': 'loadAfterExport',
				'label': stringResources.get('loadAfterExportLabel'),
				'ariaLabel': stringResources.get('loadAfterExportLabel'),
				'checked': true,
				'controlOnLeft': true
			});

			this._oLoadCheckBox.doRender();
		},

		getLoadAfterExport: function() {
			return this._oLoadCheckBox.isChecked();
		},

		remove: function() {
			this._oLoadCheckBox.remove();
			ExportView.inherited('remove', this, arguments);
		}
	});

	return ExportView;
});
